import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CompanySummary } from '../models/company-summary';

@Injectable({
  providedIn: 'root'
})
export class CompanySelectionService {
  private readonly baseUrl = environment.baseUrlWs;

  constructor(private http: HttpClient) {}

  loadCompanies(): Observable<CompanySummary[]> {
    return this.http.get<CompanySummary[]>(`${this.baseUrl}/api/company-selection`);
  }
}
